angular.module('homebot.directives')

.directive('pro', ['HelperService', '$state', 'DataService', function(helpers, $state, DataService){
  return {
    restrict: 'A',
    controllerAs: 'proCtrl',
    bindToController: {
      mlsRea: '=',
      agent: '=',
      brokerageName: '@',
      isLenderAdmin: '@',
    },
    scope: {},
    templateUrl: function(el, attrs){
      return attrs.templateUrl || '/homes/templates/partials/pro-card-inner.html';
    },

    controller: function(){
      var ctrl = this;

      ctrl.startDate = moment().subtract(30, 'days').startOf('day').toDate();

      if(!helpers.isFalsey(ctrl.isLenderAdmin))
        ctrl.isLenderAdmin = true;

      function mapAgentToPro(agent){
        var pro = _.clone(agent);

        pro.profile_url = pro.website;

        if(ctrl.brokerageName)
          pro.office = {brokerage:{name: ctrl.brokerageName}};

        return pro;
      };

      function updateJobTitle(){
        if(!ctrl.pro || (ctrl.pro && ctrl.pro.jobTitle))
          return;

        ctrl.pro.jobTitle = ctrl.isLender() ? 'Your Mortgage Pro' : 'Real Estate Agent';
      };

      ctrl.setupOfficeAddress = function(){
        if(ctrl.agent && ctrl.agent.office && ctrl.agent.office.brokerage &&
           ctrl.agent.office.brokerage.showAddress){

          ctrl.officeAddressFirstLine = ctrl.agent.office.address.street;

          ctrl.officeAddressSecondLine = `${ctrl.agent.office.address.city}, ${ctrl.agent.office.address.state} ${ctrl.agent.office.address.zip}`;

          ctrl.officeAddressFull = `${ctrl.officeAddressFirstLine}, ${ctrl.officeAddressSecondLine}`;

          ctrl.showOfficeAddress = true;
        }else{
          ctrl.showOfficeAddress = false;
        };
      };

      ctrl.isLender = function(){
        if(ctrl.agent && ctrl.agent.type === 'mortgage')
          return true;

        return false;
      };

      ctrl.update = function(){
        if(ctrl.mlsRea)
          ctrl.pro = mapAgentToPro(ctrl.mlsRea);
        else
          ctrl.pro = ctrl.agent;

        updateJobTitle();
      };

      ctrl.updateAgentData = function(){
        ctrl.updatingAgentData = true;

        DataService.updateRealEstateAgent(ctrl.pro.id)
          .then(function(agent){
            ctrl.updatingAgentData = false;

            if(agent.photo)
              agent.photo = agent.photo + '?' + _.random(1000); // bust photo cache
            ctrl.mlsRea = agent;
          });
      };

      ctrl.setupOfficeAddress();
    },

    link: function($scope, el, attrs, ctrl){
      $scope.$watch('proCtrl.mlsRea', ctrl.update);
      $scope.$watch('proCtrl.agent', ctrl.update);
    }
  }
}]);
